<template>
  <div class="wrapper">
    <div class="animated fadeIn">
      <b-row>
        <b-col sm="12">
          <b-card header-class="redmfu" >
            <div slot="header" >
              <strong v-if="thai_student==1">แจ้งความจำนงเข้ารับพระราชทานปริญญาบัตร</strong>
              <strong v-else>Confirmation of intention to attend (or not attend) the MFU Commencement Ceremony</strong>
              <strong
                style="float:right; color:wheat ;"
              >Session Timeout : {{this.$store.state.timeExp}}</strong>
            </div>
            <b-form-group label-cols-sm="1" label label-align-sm="right" label-for="nested-street">
              <b-form-group :label-cols="12" :label="regis_name"></b-form-group>
              {{status_txt}}
              <div
                v-if="selected_regis=='22' || selected_regis=='23' || selected_regis=='24' || selected_regis=='50' || selected_regis=='60' || selected_regis=='70'"
              >
                &nbsp&nbsp&nbsp&nbsp&nbsp
                <label class="mr-sm-2" v-if="thai_student==1">ระบุเหตุผล</label>
                <label class="mr-sm-2" v-if="thai_student==0">Other reasons</label>

                {{ other_txt }}
              </div>&nbsp&nbsp&nbsp&nbsp&nbsp
              <div v-if="selected_regis=='21'">
                {{ selected_month }}
                <label
                  class="mr-sm-2"
                  v-if="thai_student==1"
                >เดือน อายุครรภ์ให้ระบุถึง ณ เดือนกุมภาพันธ์ 2563</label>
                <label class="mr-sm-2" v-if="thai_student==0">month</label>
              </div>
            </b-form-group>
          </b-card>
        </b-col>
      </b-row>
      <table align=center>
      <div slot="footer" class="text-right" >
        <b-button type="submit" size="md" class="mr-2" variant="primary" @click="onBack">
          <i class="fa fa-dot-circle-o"></i> Back
        </b-button>
        <b-button type="submit" size="md" class="mr-2" variant="danger" @click="onSubmit">
          <i class="cid-account-logout"></i> Logout
        </b-button>
      </div>
      </table>
    </div>
  </div>
</template>

<script>
import YimoVueEditor from "../../../node_modules/yimo-vue-editor/src/Editor.vue";
import api from "../../service/api";

export default {
  components: { YimoVueEditor },
  name: "CreateRegisdetail",
  data() {
    return {
      student: {},
      std_id: "",
      numEror: 0,
      current_erorrtxt: "",
      selected_regis: "",
      other_txt: "",
      status_txt:"",
      selected_month: 0,
      dangerModal: false,
      items: [],
      actionUpdate: 10,
      levelid: "",

      regis_name: ""
    };
  },
  // watch: {
  //   test: function() {
  //     console.log("t1 ", test);
  //   }
  // },
  methods: {
    getStatus(thaistudent,id) {
      api
        .getRegisTypeID(thaistudent,id)
        .then(res => {
          // console.log("getStatus==",res.data)
          if (res.data.data.length == 1) {
            this.status_txt=res.data.data[0].BYTEDES;
          } else {

          }
        })
        .catch(err => {
          console.log("getStatus==", err.toString());
        });
    },
    getCurrentStudent(studentid) {
      api
        .getStudentUserQuestionById(studentid)
        .then(res => {
          var currentSt = res.data.data[0];
          if (res.data.data.length == 1) {
            this.actionUpdate = 1;
            // console.log("res=", res);
            // console.log(" getCurrentStudent มีข้อมูล", this.actionUpdate);
            this.std_id = this.student.STUDENTID;
            this.selected_regis = currentSt.GRADUATE_STATUS;
            this.getStatus(this.thai_student,this.selected_regis )
            this.q1 = currentSt.QUESTIONNAIRE_1;
            this.q2 = currentSt.QUESTIONNAIRE_2;
            this.q3 = currentSt.QUESTIONNAIRE_3;
            this.q4 = currentSt.QUESTIONNAIRE_4;
            if (this.thai_student==1) {
              this.regis_name = currentSt.BYTEDES;
            }else if  (this.thai_student==0){
              this.regis_name = currentSt.BYTEDES_ENG;
            }

            if (currentSt.GRADUATE_STATUS == 21) {
              this.selected_month = currentSt.OTHER;
            } else if (
              currentSt.GRADUATE_STATUS == 22 ||
              currentSt.GRADUATE_STATUS == 23 ||
              currentSt.GRADUATE_STATUS == 24 ||
              currentSt.GRADUATE_STATUS == 50 ||
              currentSt.GRADUATE_STATUS == 60||
              currentSt.GRADUATE_STATUS == 70
            ) {
              this.other_txt = currentSt.OTHER;
            } else {
              this.other_txt = "";
            }
          } else {
            this.actionUpdate = 0;
            console.log(" getCurrentStudent ไม่มีข้อมูล", this.actionUpdate);
          }
        })
        .catch(err => {
          console.log("getCurrentStudent", err.toString());
          this.actionUpdate = 10;
          this.$router.push("Logout");
        });
    },

    setStudent: function() {
      this.student.std_id = this.$store.state.user.studentid;
      this.student.selected_regis = this.selected_regis;

      if (this.selected_regis == 21) {
        this.student.other_txt = this.selected_month;
        this.student.selected_month = "";
      } else if (
        this.selected_regis == 22 ||
        this.selected_regis == 23 ||
        this.selected_regis == 24 ||
        this.selected_regis == 50 ||
        this.selected_regis == 60
      ) {
        this.student.other_txt = this.other_txt;
      } else {
        this.student.other_txt = "";
        this.student.selected_month = "";
      }

      console.log("setStudent==", this.student);
      return this.student;
    },

    getErrorTxt: function() {
      this.current_erorrtxt = "";
      this.numEror = 0;
      if (
        (this.selected_regis == 22 ||
          this.selected_regis == 23 ||
          this.selected_regis == 24 ||
          this.selected_regis == 50 ||
          this.selected_regis == 60) &&
        this.other_txt == ""
      ) {
        this.numEror = this.numEror + 1;
        this.current_erorrtxt =
          this.thai_student == "1"
            ? this.current_erorrtxt + "/ระบุเหตุผล "
            : this.current_erorrtxt + "/Please specify";
      }
      if (this.selected_regis == 21 && this.selected_month == 0) {
        this.numEror = this.numEror + 1;
        this.current_erorrtxt =
          this.thai_student == "1"
            ? this.current_erorrtxt + "/เลือกจำนวนเดือน "
            : this.current_erorrtxt + "/Select month";
      }

      if (this.thai_student == 1) {
        if (this.levelid == 3) {
          if (this.q1 + this.q2 + this.q3 + this.q4 != 4) {
            this.numEror = this.numEror + 1;
            this.current_erorrtxt =
              "ค้างตอบแบบสอบถามอื่นๆ กรุณากลับไปที่ เมนูหน้าหลัก";
          }
        } else {
          if (this.q1 + this.q4 != 2) {
            this.numEror = this.numEror + 1;
            this.current_erorrtxt =
              "ค้างตอบแบบสอบถามอื่นๆ กรุณากลับไปที่ เมนูหน้าหลัก";
          }
        }
      } else {
        if (this.q1 + this.q4 != 2) {
          this.numEror = this.numEror + 1;
          this.current_erorrtxt = "Back to Home Menu";
        }
      }

      if (this.numEror == 0) {
        this.dangerModal = false;
      } else {
        this.dangerModal = true;
      }
      return this.numEror;
    },
    onBack(){
      this.$router.push("Main");
    },
    onSubmit() {
      this.$router.push("/Logout");
      // this.setStudent();
      // console.log("student save=", this.student);
      // this.numEror = this.getErrorTxt(this.student);
      // console.log("numEror save=", this.numEror);
      // if (this.numEror == 0) {
      //   if (this.actionUpdate == false) {
      //     // save
      //     this.$router.push("General");
      //   } else {
      //     // update
      //     this.onUpdateData(this.student);
      //   }
      // }
    },
    nextPart() {
      if (
        this.selected_regis == 10 ||
        this.selected_regis == 21 ||
        this.selected_regis == 22 ||
        this.selected_regis == 23 ||
        this.selected_regis == 24 ||
        this.selected_regis == 30 ||
        this.selected_regis == 40
      ) {
        this.$router.push("/Confirm");
      } /*else if ((this.selected_regis==10) || (this.selected_regis==21) || (this.selected_regis==22)|| (this.selected_regis==23)
       || (this.selected_regis==24) || (this.selected_regis==30) || (this.selected_regis==40) ){
         //this.$router.push("/Dashboard"); //พริ้นใบรายงาน
         this.$router.push("/Dashboard");

       } */ else if (
        this.selected_regis == 50 ||
        this.selected_regis == 60
      ) {
        this.$router.push("/Post"); //เลือกส่งไปรณีย์หรือมารับด้วยต้นเอง
      }
    },
    onUpdateData() {
      api
        .updateStudentRegis(this.student)
        .then(res => {
          console.log(res);
          this.message = res.message;
          console.log("update ผ่าน", this.studentId);
          this.nextPart();
        })
        .catch(err => {
          console.log(2);
          console.log("onUpdateData error", err.toString());
        });
    },
    getRegisType: function(thaistudent) {
      api
        .getRegisTypeAll(thaistudent)
        .then(res => {
          this.items = res.data.data;
          // console.log(this.items);
        })
        .catch(err => {
          console.log("2 getQuestionBySection", err.toString());
        });
    },
    checkBeforeRegis() {}
  },
  mounted() {},
  created() {
    if (this.$store.state.token == null || this.$store.state.user == null) {
      this.$router.push("/Logout");
    } else {
      // this.$router.push("/Dashboard");
    }
    this.std_id = this.$store.state.user.studentid;
    this.thai_student = this.$store.state.user.thaistudent;
    this.levelid = this.$store.state.user.levelid;
    api.onSetHeader();
    this.actionUpdate = this.getCurrentStudent(this.std_id);
    // this.getRegisType(this.thai_student);
  }
};
</script>
<style>
.redmfu{
  background-color: #960018;
  color: white;
}
</style>
